import { CommonSlice } from './reducer';
import { checkTestEvent, createTestEvent, deleteTestEvent } from './services';
import { RETCODE_SUCCESS, RETTEXT_SUCCESS } from '@configs/contants';
import { message } from 'antd';

export const { setLanguage, setPinCode, setStatusTesting, setLoading } = CommonSlice.actions;

export const onSetLanguage = (lang) => async (dispatch) => {
  dispatch(setLanguage(lang));
};

const PIN_STORAGE_DURATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 ngày - đảm bảo lưu trữ an toàn trong suốt sự kiện

export const getStoredPinCode = (action = 'lucky-draw', eventId) => {
  try {
    const keys = [];
    if (action && eventId) keys.push(`PIN_SESSION_${action}_${eventId}`);
    if (eventId) keys.push(`PIN_SESSION_${eventId}`);
    if (action) keys.push(`PIN_SESSION_${action}`);
    keys.push('PIN_SESSION_LATEST');

    for (const key of keys) {
      const raw = localStorage.getItem(key);
      if (raw) {
        const item = JSON.parse(raw);
        if (item && item.pinCode) {
          // Kiểm tra thời hạn lưu trữ (7 ngày)
          if (!item.expiresAt || item.expiresAt > Date.now()) {
            if (!action || !item.action || item.action === action) {
              return item;
            }
          } else {
            localStorage.removeItem(key);
          }
        }
      }
    }
  } catch (e) {
    console.error('Error reading pin from localStorage', e);
  }
  return null;
};

export const clearStoredPinCode = (action, eventId) => {
  try {
    if (action && eventId) localStorage.removeItem(`PIN_SESSION_${action}_${eventId}`);
    if (eventId) localStorage.removeItem(`PIN_SESSION_${eventId}`);
    if (action) localStorage.removeItem(`PIN_SESSION_${action}`);
    localStorage.removeItem('PIN_SESSION_LATEST');
  } catch (e) {
    console.error('Error clearing pin from localStorage', e);
  }
};

export const onSetPinCode = (payload, eventId) => async (dispatch) => {
  if (payload && payload.pinCode) {
    try {
      const pinData = {
        action: payload.action,
        pinCode: payload.pinCode,
        eventId: eventId || payload.eventId,
        savedAt: Date.now(),
        expiresAt: Date.now() + PIN_STORAGE_DURATION_MS,
      };
      if (pinData.action && pinData.eventId) {
        localStorage.setItem(`PIN_SESSION_${pinData.action}_${pinData.eventId}`, JSON.stringify(pinData));
      }
      if (pinData.action) {
        localStorage.setItem(`PIN_SESSION_${pinData.action}`, JSON.stringify(pinData));
      }
      localStorage.setItem('PIN_SESSION_LATEST', JSON.stringify(pinData));
    } catch (e) {
      console.error('Error storing pin to localStorage', e);
    }
  } else if (!payload) {
    clearStoredPinCode(undefined, eventId);
  }
  dispatch(setPinCode(payload));
};

export const onSetStatusCheckEvent = (payload) => async (dispatch) => {
  dispatch(setStatusTesting(payload));
};

export const onCreateTestEvent = (payload) => async (dispatch) => {
  try {
    setLoading(true);
    const res = await createTestEvent(payload);
    if (res.retCode !== RETCODE_SUCCESS) {
      message.error(res?.retText);
      return;
    }
    if (!!res.data) {
      dispatch(setStatusTesting(res.data));
    }
  } catch (err) {
    dispatch(setLoading(err));
    throw new Error(err);
  } finally {
    dispatch(setLoading(true));
  }
};

export const onCheckTestEvent = (eventId) => async (dispatch) => {
  try {
    setLoading(true);
    const res = await checkTestEvent(eventId);
    if (res.retCode !== RETCODE_SUCCESS) {
      message.error(res?.retText);
      return;
    }
    if (!!res.data) {
      dispatch(setStatusTesting(res.data));
    }
  } catch (err) {
    dispatch(setLoading(err));
    throw new Error(err);
  } finally {
    dispatch(setLoading(true));
  }
};

export const onDeleteTestEvent = (payload) => async (dispatch) => {
  try {
    setLoading(true);
    const res = await deleteTestEvent(payload);
    if (res.retCode !== RETCODE_SUCCESS) {
      message.error(res?.retText);
      return;
    }
    dispatch(setStatusTesting(undefined));
  } catch (err) {
    dispatch(setLoading(err));
    throw new Error(err);
  } finally {
    dispatch(setLoading(true));
  }
};

export const getToken = () => {
  return localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
}
